import React from 'react'
import { Link } from 'react-router-dom'
import { generatePath } from 'react-router'
import {
  Button,
  Image,
  Section,
  SupplierScoreMeter,
  Modal,
} from '../../components'
import NumberFormat from 'react-number-format'
import { supplierController } from '../../apiService'
import { ROUTE_PATH, STRING } from '../../helpers'
import { ICONS } from '../../themes'
import { store } from 'store'

export class MainDirectoryBlock extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isDisabled: false,
      info: [],
      isModalIsOpen: false,
      mainDirectoryList: [],
    }
  }

  addTolist = e => {
    this.props.mainDirectoryList(e)
  }

  toggleModal = () => {
    this.setState(prevState => ({
      isModalIsOpen: !prevState.isModalIsOpen,
    }))
  }

  render() {
    const { info } = this.props
    const businessTypeLength = info.business_type.length
    const { role } = store.getState()

    // console.log('supplierListX', [...selectsupplierList])

    return (
      <>
        <Section className="supplier-discovery-block">
          <Section className="info-wrapper">
            <div className="supplier-header">
              <div className="supplier-name-and-address">
                <div className="supplier-name-and-signs">
                  <Link
                    className="supplier-name"
                    to={generatePath(
                      ROUTE_PATH.SUPPLIER_DISCOVERY_INFORMATION.LINK,
                      { id: info.id }
                    )}
                  >
                    {info.company_name}
                  </Link>

                  <div className="signs">
                    <Button
                      className="link"
                      onClick={() => this.props.onIconClick(info)}
                    >
                      <Image
                        className="supplier-sign"
                        src={ICONS['icon-contact-sign.svg']}
                        alt="contact sign"
                      />
                    </Button>
                    {info.status_account === 2 ? (
                      <Button
                        className="link"
                        onClick={() => this.props.onIconWarning(info)}
                      >
                        <Image
                          className="supplier-sign"
                          src={ICONS['icon-warning-sign.svg']}
                          alt="warning sign"
                        />
                      </Button>
                    ) : null}
                  </div>
                </div>

                <div className="supplier-address">
                  {`${info.regis_address}`}
                </div>
              </div>

              <div className="scoreboard">
                {/* <SupplierScoreMeter
                  name="Financial"
                  maxValue={5}
                  value={info.financial}
                /> */}

                {info.ss && info.ss <= 5 ? (
                  <SupplierScoreMeter name="SS" maxValue={5} value={info.ss} />
                ) : null}

                {info.esg ? (
                  <div className="esg-score">
                    <div className="score">
                      {info.esg === 'InProgress' ? 'In progress' : info.esg}
                    </div>
                    <div className="label">{STRING.ESG}</div>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="supplier-info">
              <div className="col">
                <div className="info-block">
                  <div className="label">{STRING.TAX_ID}:</div>

                  <div className="data">{info.tax_id}</div>
                </div>

                <div className="info-block">
                  <div className="label">{STRING.YEAR_ESTABLISHED}:</div>

                  <div className="data">{info.year_established}</div>
                </div>
              </div>

              <div className="col">
                <div className="info-block">
                  <div className="label">{STRING.BUSINESS_TYPE}:</div>
                  {info.business_type.length == '' ? (
                    <div className="data">N/A</div>
                  ) : (
                    <div className="data">
                      {info.business_type.map((businessType, i) =>
                        businessTypeLength === i + 1
                          ? businessType.name
                          : businessType.name + ', '
                      )}
                    </div>
                  )}
                </div>

                <div className="info-block">
                  <div className="label">{STRING.REGISTERED_CAPITAL}:</div>

                  <div className="data">
                    <NumberFormat
                      value={info.regis_capital}
                      displayType={'text'}
                      thousandSeparator={true}
                    />
                    {` ${STRING.THB}`}
                  </div>
                </div>
              </div>

              <div className="col fluid">
                <div className="info-block">
                  <div className="label">{STRING.SERVICE_CATEGORY}:</div>

                  <div className="data">
                    {info.service_category &&
                      info.service_category.map(item => (
                        <span key={item.category_id}>
                          <div
                            key={item.sub_category_id}
                          >{`${item.category_name} > ${item.sub_category_name}`}</div>
                        </span>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </Section>

          <Section className="actions">
            {/* {
              // console.log(e)
              selectsupplierList.find(e => e.tax_id === info.tax_id) ? (
                <Button
                  disabled={true}
                  className="theme-blue"
                  onClick={() => {
                    console.log(info)
                  }}
                >
                  Selected
                </Button>
              ) : (
                <Button
                  className="theme-blue"
                  onClick={() => {
                    this.addTolist(info)
                  }}
                >
                  Select
                </Button>
              )
            } */}

            {info.status == 'Unavailable' ? (
              <Button disabled={true} className="theme-blue">
                Supplier was added
              </Button>
            ) : (
              <Button
                className="theme-blue"
                onClick={() => this.props.onAddMySupplier(info)}
              >
                Add to My Supplier
              </Button>
            )}
          </Section>
        </Section>
      </>
    )
  }
}
